export const formatFormErrorMessage = (errors: Error[]) => {
  const errorMessages = errors.map(err => err?.message ?? undefined)
  return errorMessages.join(', ')
}
